import { render } from "./LocationPinIcon.vue?vue&type=template&id=15924de4"
import script from "./LocationPinIcon.vue?vue&type=script&lang=js"
export * from "./LocationPinIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__